/** 国家/区域名称 */
export type CountryCode = 'SG' | 'MY' | 'TH' | 'VN' | 'US' | 'ID' | 'CN' | 'TW' | 'AU'

/** 钱包账户对应地区的多语言的key*/
export const WALLET_COUNTRY_NAME = {
  SG: 'wallet.accountSG',
  MY: 'wallet.accountMY',
  TH: 'wallet.accountTH',
  VN: 'wallet.accountVN',
  HK: 'wallet.accountHK',
  CN: 'wallet.accountCN',
  TW: 'wallet.accountTW',
  ID: 'wallet.accountID',
  US: 'wallet.accountUS',
  AU: 'wallet.accountAU',
}
